import posthog from "posthog-js";

/** Surfaces that host the listing quick-preview modal. */
export type ItemPreviewSurface = "homepage" | "market";

export type ItemPreviewCta =
  | "opened"
  | "buy"
  | "find_more"
  | "view_details"
  | "dismiss";

export const ITEM_PREVIEW_OPENED_EVENT = "item_preview_opened" as const;
export const ITEM_PREVIEW_BUY_CLICKED_EVENT =
  "item_preview_buy_clicked" as const;
export const ITEM_PREVIEW_FIND_MORE_CLICKED_EVENT =
  "item_preview_find_more_clicked" as const;
export const ITEM_PREVIEW_VIEW_DETAILS_CLICKED_EVENT =
  "item_preview_view_details_clicked" as const;
export const ITEM_PREVIEW_DISMISSED_EVENT = "item_preview_dismissed" as const;

const EVENT_BY_CTA: Record<ItemPreviewCta, string> = {
  opened: ITEM_PREVIEW_OPENED_EVENT,
  buy: ITEM_PREVIEW_BUY_CLICKED_EVENT,
  find_more: ITEM_PREVIEW_FIND_MORE_CLICKED_EVENT,
  view_details: ITEM_PREVIEW_VIEW_DETAILS_CLICKED_EVENT,
  dismiss: ITEM_PREVIEW_DISMISSED_EVENT,
};

export type CaptureItemPreviewParams = {
  cta: ItemPreviewCta;
  surface: ItemPreviewSurface;
  listingId: string;
  category?: string | null;
  subcategory?: string | null;
  listingPrice?: number | null;
};

/**
 * Listing quick-preview funnel (homepage + market).
 * Single owner — call from ItemPreviewModal only so surfaces stay consistent.
 */
export function captureItemPreview(params: CaptureItemPreviewParams): void {
  try {
    posthog.capture(EVENT_BY_CTA[params.cta], {
      listing_id: params.listingId,
      surface: params.surface,
      category: params.category ?? null,
      subcategory: params.subcategory ?? null,
      listing_price:
        typeof params.listingPrice === "number" &&
        Number.isFinite(params.listingPrice)
          ? params.listingPrice
          : null,
    });
  } catch (error) {
    console.warn(`[posthog] item_preview_${params.cta} capture failed:`, error);
  }
}
